import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { CookieBanner } from "./components/CookieBanner";
import { Landing } from "./pages/Landing";
import { Buy } from "./pages/Buy";
import { Thanks } from "./pages/Thanks";
import { Regulamin } from "./pages/Regulamin";
import { Polityka } from "./pages/Polityka";
import { AuthProvider } from "./lib/auth";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminDashboard } from "./pages/admin/Dashboard";
import { AdminSales } from "./pages/admin/Sales";
import { AdminSaleDetail } from "./pages/admin/SaleDetail";
import { AdminUsers } from "./pages/admin/Users";
import { AdminOverlay } from "./pages/admin/Overlay";
import { AdminQueue } from "./pages/admin/Queue";
import { AdminSettings } from "./pages/admin/Settings";
import { AdminDiagnostics } from "./pages/admin/Diagnostics";
import { AdminGraph } from "./pages/admin/Graph";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/thanks" element={<Thanks />} />
            <Route path="/thanks/:id" element={<Thanks />} />
            <Route path="/regulamin" element={<Regulamin />} />
            <Route path="/polityka-prywatnosci" element={<Polityka />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="sales" element={<AdminSales />} />
              <Route path="sales/:id" element={<AdminSaleDetail />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="overlay" element={<AdminOverlay />} />
              <Route path="queue" element={<AdminQueue />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="diagnostics" element={<AdminDiagnostics />} />
              <Route path="graph" element={<AdminGraph />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
